import { render, staticRenderFns } from "./index.vue?vue&type=template&id=11033cfe&vue3"
import script from "./index.vue?vue&type=script&lang=js&vue3"
export * from "./index.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports